export class ConfirmAgreedPriceTransactionsError extends Error {}
